module.exports = __webpack_public_path__ + "static/img/boeing.9de944d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kitchen_aid/boeing.png
// module id = TEdW
// module chunks = 1